module.exports = __webpack_public_path__ + "img/06.d0bb3ae3.jpg";